/* eslint-disable react/display-name */
// Packages
import { forwardRef } from 'react'
// Hooks
import useAuth from '../../../hooks/useAuth'
import { useTranslation } from 'react-i18next'
// Components
import SettingIcon from '../../../components/icons/SettingIcon'
import SignOutIcon from '../../../components/icons/SignOutIcon'
import Avatar from './Avatar'
import UserInfo from './UserInfo'
import UserMenuItem from './UserMenuItem'
import LockIcon from '../../../components/icons/LockIcon'
import { useNavigate } from 'react-router-dom'

type IProps = {
  show: boolean
  handleClick: () => void
}

type Ref = HTMLDivElement

const UserMenu = forwardRef<Ref, IProps>(({ show, handleClick }, ref) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { logOut } = useAuth()
  const handleLogoutClick = () => {
    logOut()
  }
  const handleResetPasswordClick = () => {
    navigate('/ResetPassword')
  }
  return show ? (
    <div ref={ref} className='absolute w-56 h-60 top-11 -left-2 rounded-lg bg-white shadow-xl'>
      {/* User Info */}
      <div className='flex items-center h-1/4 p-3 border-b border-gray-200'>
        <Avatar classes='ml-2' />
        <UserInfo classes='flex' />
      </div>

      {/* User menu List */}
      <div className='p-3 h-2/4'>
        <UserMenuItem icon={<SettingIcon />} title={t('myInfo')} handleClick={handleClick} />
        <UserMenuItem
          icon={<LockIcon />}
          title={t('changePassword')}
          handleClick={() => {
            handleClick()
            handleResetPasswordClick()
          }}
        />
      </div>

      {/* Signout */}
      <div
        className='flex items-center p-3 h-1/4 cursor-pointer text-gray-400 hover:text-blue-400 text-sm border-t border-t-gray-200'
        onClick={handleLogoutClick}
      >
        <SignOutIcon classes='cursor-none' />
        <span className='mr-3'>خروج از حساب کاربری</span>
      </div>
    </div>
  ) : null
})

export default UserMenu
